export default "__VITE_ASSET__27108195__"